import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-school-page',
  templateUrl: './about-school-page.component.html',
  styleUrls: ['./about-school-page.component.css']
})
export class AboutSchoolPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
